import { gsap } from 'gsap';
import { ScrollTrigger, Observer } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, Observer);

const InitScrollSmoother = () => {
  const init = () => {
    // ScrollTrigger.normalizeScroll(false);
    const body = document.body;
    const obsUp = (e) => {
      console.log('up');
      console.log(e.target.pageYOffset, e.deltaY);
    };
    const obsDown = (e) => {
      console.log('down');
      console.log(e.target.pageYOffset, e.deltaY);
    };
    const observerCheck = (e) => {
      if (e.deltaY > 0) {
        // down
        console.log('down');
        if (e.target.pageYOffset > 300) {
          body.classList.add('is-menu-hidden');
          body.classList.add('is-menu-thin');
        }
      } else {
        // up
        console.log('up');
        body.classList.remove('is-menu-hidden');
        if (e.target.pageYOffset <= 300) {
          body.classList.remove('is-menu-thin');
        }
      }
    };
    const obs = Observer.create({
      target: window,
      type: 'wheel, touch',
      onUp: (e) => observerCheck(e),
      onDown: (e) => observerCheck(e),
    });
    // const scroller = ScrollSmoother.create({
    //   smooth: 2,
    //   effects: true,
    // });
    // scroller.effects('.sm-title', { speed: 1.05, lag: 0.05 });
    // scroller.effects('.sm-img', { speed: 1.1, lag: 0.05 });
  };
  window.addEventListener('DOMContentLoaded', (event) => {
    init();
  });
};
export default InitScrollSmoother;
